import { Star24 } from '@workspace/ui/icons';
import type React from 'react';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';

export const StarIcon: React.FC<{
  size: number;
  className?: string;
}> = ({ size, ...props }) =>
  company.match({
    dubaiexpress: <Icon {...props} type="camel-rating" size={size} />,
    default: <Star24 {...props} width={size} height={size} />,
  });
